module.exports = __webpack_public_path__ + "img/total-guest.b567b634.svg";